import type { ZodError } from 'zod';

export type ContractErrorCode =
    | 'CONTRACT_INVALID'
    | 'CONTRACT_UNSUPPORTED_VERSION'
    | 'CONTRACT_UNKNOWN_TYPE';

export type ContractIssue = {
    path: string;
    message: string;
};

export type ContractErrorContext = {
    handler?: string;
    type?: string;
    source?: 'control-ws' | 'queue-ws' | 'http';
};

export type ContractError = {
    code: ContractErrorCode;
    message: string;
    issues?: ContractIssue[];
    context?: ContractErrorContext;
};

export const toContractError = (error: ZodError, context?: ContractErrorContext): ContractError => ({
    code: 'CONTRACT_INVALID',
    message: 'Contract validation failed',
    issues: error.issues.map((issue) => ({
        path: issue.path.join('.'),
        message: issue.message,
    })),
    context,
});
